import * as React from 'react'

import { Box, Button, InputCheckBox, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import app from 'modules/core/store/models/app'

import { DEFAULT_PERIOD_TYPE } from 'modules/attendance/components/TimeTracking/Layout/form'
import { useUpdateTimeTrackingSetting } from 'modules/attendance/components/SettingItemPage/TimeTracking/hooks/useUpdateTimeTrackingSetting'
import { useAttendanceFeatures } from 'modules/attendance/lib/attendanceFeaturesContext'
import { useAttendanceSettingWorkCategories } from 'modules/attendance/lib/attendanceSettingWorkCategoriesContext'
import { TimesheetFeatures } from 'modules/attendance/lib/timesheetFeatures'

const Navigation = () => {
  const { navigation } = useNavigation()
  const year = moment().year()
  const month = moment().month() + 1
  const pathParams = {
    periodType: DEFAULT_PERIOD_TYPE,
    year,
    month,
    day: 1,
  }
  const exportUrl = navigation.timeTracking.list.periodTypeYearMonthDay.exports.fullPath({
    ...pathParams,
  })

  const { featureAvailability: hasOverlappingSpecialHours } = useAttendanceFeatures(
    TimesheetFeatures.ALLOW_OVERLAPPING_SPECIAL_HOURS
  )

  const { attendanceSetting } = useAttendanceSettingWorkCategories()
  const { updateSetting } = useUpdateTimeTrackingSetting()

  const allowOverlapping = attendanceSetting.attributes.allow_overlapping_special_hours ?? false

  const { running: updatingOverlapping, performAction: toggleOverlapping } = useAsyncAction(
    async () => {
      const newValue = !allowOverlapping

      const result = await updateSetting({
        id: attendanceSetting.id,
        allowOverlappingSpecialHours: newValue,
      })

      const handled = handleResult(result, () => undefined)

      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })
        await attendanceSetting.fetch()
      }

      return handled
    },
    {
      successFlash: false,
      errorFlash: true,
    }
  )

  return (
    <Box gap="s48">
      <Box flexDirection="row" gap="s16" alignItems="center" justifyContent="flexEnd">
        {hasOverlappingSpecialHours && (
          <Box flexDirection="row" gap="s8" alignItems="center" style={{ marginRight: 'auto' }}>
            <InputCheckBox
              checked={allowOverlapping}
              onClick={toggleOverlapping}
              disabled={updatingOverlapping}
            />
            <Text size="200" weight="medium">
              {i18n.t(
                'time_tracking.settings.work_time_categories.special_work_hours.allow_overlapping_special_hours'
              )}
            </Text>
          </Box>
        )}
        <Button.Router
          type="secondary"
          to={exportUrl}
          onClick={() =>
            track(trackingEvents.timeTracking.specialHoursTableDownloadWorkedHoursButtonPressed)
          }
        >
          {i18n.t(
            'time_tracking.settings.work_time_categories.special_work_hours.info_section.button_title'
          )}
        </Button.Router>
      </Box>
    </Box>
  )
}

export default Navigation
